import Halog from 'types/halog';
import { FC, useEffect, useState } from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import useAuth from 'hooks/useAuth';

interface ChildComponentProps {
    halog?: Halog;
    onSwitch(halog: Halog, currentTenantId: string): any;
    onClose(): any;
}

const HalogSwitchTenant: FC<ChildComponentProps> = (props) => {
    const { halog, onSwitch, onClose } = props;
    const [open, setOpen] = useState(false);
    const [halogCopy, setHalogCopy] = useState(halog);
    const theme = useTheme();
    const { user } = useAuth();
    const { t } = useTranslation();
    const mobileDevice = useMediaQuery(theme.breakpoints.down('md'));
    const [currentTenantId, setCurrentTenantId] = useState(halog?.tenantId);

    useEffect(() => {
        (async () => {
            setCurrentTenantId(user?.tenants.find((x) => x.id !== user.tenantId)?.id);
            if (halog === undefined) setOpen(false);
            else {
                setOpen(true);
                setHalogCopy(halog);
            }
        })();
    }, [halog]);

    return (
        <>
            <Dialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {t('SWITCH_TENANT')} {halog?.name}
                    {halog?.identifier && (
                        <Typography>
                            {t('IDENTIFIER')}: {halog?.identifier}
                        </Typography>
                    )}
                </DialogTitle>
                <DialogContent sx={{ paddingTop: '6px!important', width: mobileDevice ? window.innerWidth - 65 : 500 }}>
                    {user?.tenants && user?.tenants.length > 0 && (
                        <Box sx={{ p: 2 }}>
                            <FormControl fullWidth>
                                <InputLabel>Tenant</InputLabel>
                                <Select
                                    label="Tenant"
                                    onChange={(event) => {
                                        setCurrentTenantId(event.target.value);
                                    }}
                                    defaultValue={user?.tenants.find((x) => x.id !== user.tenantId)?.id}
                                    onClick={(event) => event.stopPropagation()}
                                >
                                    {user?.tenants?.map(
                                        (tenant) =>
                                            user.tenantId !== tenant.id && (
                                                <MenuItem key={tenant.id} value={tenant.id}>
                                                    {tenant.name}
                                                </MenuItem>
                                            )
                                    )}
                                </Select>
                            </FormControl>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Grid
                        container
                        sx={{ alignItems: 'center', justifyContent: 'space-between', paddingLeft: '15px', paddingRight: '15px' }}
                    >
                        <Grid item>
                            <Button
                                onClick={onClose}
                                autoFocus
                                style={{
                                    border: '2px solid',
                                    borderColor: theme.palette.secondary.main,
                                    borderRadius: 7,
                                    marginRight: 10
                                }}
                            >
                                <Typography sx={{ color: theme.palette.primary.main }}> {t('CANCEL')}</Typography>
                            </Button>
                            <Button
                                onClick={() => onSwitch(halogCopy!, currentTenantId!)}
                                style={{
                                    border: '2px solid',
                                    borderColor: theme.palette.primary.main,
                                    borderRadius: 7,
                                    background: theme.palette.primary.main
                                }}
                            >
                                <Typography sx={{ color: '#fff' }}> {t('SAVE')}</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default HalogSwitchTenant;
